<div class="titleBar">
    <p class="title "><span class="iconSection"><em class=" mx-2 " [ngClass]="faicon"></em></span> {{title}}</p>
    <p *ngIf="showLastupdated" class="dateClass">Last Updated : {{lastUpdatedDate| date: 'MMM dd yyyy'}}</p>
</div>